type ErrorDialogProps = {
  title?: string
  message: string
  onClose: () => void
}

export default function ErrorDialog({ title = "Something went wrong", message, onClose }: ErrorDialogProps) {
  return (
    <div className="fixed inset-0 z-[80] flex items-end justify-center bg-black/70 p-4 sm:items-center">
      <div className="w-full max-w-sm rounded-2xl border border-[#1F1F1F] bg-[#141414] p-5 shadow-2xl">
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#00C805]">Error</p>
        <h2 className="mt-2 text-lg font-semibold text-white">{title}</h2>
        <p className="mt-2 text-sm leading-6 text-[#A8A8A8]">{message}</p>
        <button
          type="button"
          onClick={onClose}
          className="mt-5 w-full rounded-xl bg-[#00C805] py-2.5 text-sm font-semibold text-black"
        >
          Close
        </button>
      </div>
    </div>
  )
}
